import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";

export class PRGameMode extends GameMode {
    public static readonly FREESPIN_LEVEL_ONE: string = "FREESPIN_LEVEL_ONE";
    public static readonly FREESPIN_LEVEL_TWO: string = "FREESPIN_LEVEL_TWO";
    public static readonly FREESPIN_LEVEL_THREE: string = "FREESPIN_LEVEL_THREE";
}